import axios from "axios";

export default {
  name: "Auth",
  created() {
    axios.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          // if you ever get an unauthorized, logout the user
          this.$store.dispatch('app/authLogout').then(resolve)
          // you can also redirect to /login if needed !
        }
        throw err;
      });
    });
  }
}